<template>
    <div v-for="index in 4" :key="index">
        <div class="rounded-sm px-2 py-2">
            <div class="w-full h-32 w-full animate-pulse rounded bg-slate-200" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'SkeletonQuotaUsage',
}
</script>
